var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.62132034,12 L17.5606602,19.561276 C18.1464466,20.1191679 18.1464466,21.0236893 17.5606602,21.5815811 C16.9748737,22.139473 16.0251263,22.139473 15.4393398,21.5815811 L6.43933983,13.0101525 C5.85355339,12.4522607 5.85355339,11.5477393 6.43933983,10.9898475 L15.4393398,2.41841888 C16.0251263,1.86052704 16.9748737,1.86052704 17.5606602,2.41841888 C18.1464466,2.97631073 18.1464466,3.88083213 17.5606602,4.43872397 L9.62132034,12 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeft);
export default __webpack_public_path__ + "static/media/CaretLeft.c525158fd47bd88646786c22c7b24bd7.svg";
export { ForwardRef as ReactComponent };